import { Keyboard } from 'react-native';
import {
  BottomSheetContainer,
  createUseBottomSheetModal,
  KeyboardAvoiding,
  useSafeArea,
  useScreenSize,
} from '@banhala/ui-kit';
import { isIOS, isWeb } from 'shared/src/utils';
import { useUpdateFolder } from '../../../queries/useUpdateFolder';
import { FolderNameEditor } from '../components/FolderNameEditor';

export const useRenameFolderBottomSheet = createUseBottomSheetModal<
  { folderSno: number; folderName: string },
  { sno: number; initialTitle: string; coverImage: string | null }
>(({ confirm, cancel, param }) => {
  const { mutateAsync: updateFolder } = useUpdateFolder();
  const { bottom, top } = useSafeArea();
  const { height: screenHeight } = useScreenSize();

  return (
    <KeyboardAvoiding>
      <BottomSheetContainer
        onPressClose={() => {
          Keyboard.dismiss();
          cancel();
        }}
        minHeight={
          isWeb
            ? screenHeight / 3
            : isIOS
              ? (screenHeight - bottom - top) / 3
              : 0
        }
        title="서랍 이름 바꾸기"
      >
        <FolderNameEditor
          initialValue={param.initialTitle}
          validate={value => value.length > 0 && value !== param.initialTitle}
          onSubmit={async value => {
            await updateFolder({
              sno: param.sno,
              title: value,
              image: param.coverImage,
            });
            confirm({ folderSno: param.sno, folderName: value });
          }}
          onClose={cancel}
        />
      </BottomSheetContainer>
    </KeyboardAvoiding>
  );
});
